<template>
    <div class="border rounded-lg p-4 mt-4">
      <h2 class="text-lg font-bold mb-2">Código promocional</h2>
      <div class="flex">
        <input 
          type="text" 
          v-model="promoCode" 
          placeholder="Ingresa tu código" 
          class="border rounded-l-lg px-3 py-2 flex-grow focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
        <button 
          @click="applyPromoCode" 
          class="bg-blue-800 hover:bg-sky-700 text-white font-bold py-2 px-4 rounded-r-lg"
        >
          Aplicar
        </button>
      </div>
      <div v-if="errorMessage" class="text-red-500 mt-2">{{ errorMessage }}</div>
      <div v-if="successMessage" class="text-green-500 mt-2">{{ successMessage }}</div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        promoCode: '',
        errorMessage: '',
        successMessage: '',
      };
    },
    methods: {
      applyPromoCode() {
        // Lógica para validar y aplicar el código promocional
        if (this.promoCode === 'DESCUENTO10') {
          // Aquí podrías emitir un evento para actualizar el descuento en el componente Summary
          this.$emit('promo-code-applied', 10); // Ejemplo: 10% de descuento
          this.successMessage = 'Código aplicado correctamente';
          this.errorMessage = '';
        } else {
          this.errorMessage = 'Código inválido';
          this.successMessage = '';
        }
      },
    },
  };
  </script>